import React from "react";
import ExpeditionList from "../../../components/user/standAloneProcess/expedition";
import Layout from "../../../components/layouts/verticalLayout";

const ExpeditionListPage = (props) => {
  return <Layout body={<ExpeditionList />} />;
};

ExpeditionListPage.propTypes = {};

export default ExpeditionListPage;
